import { render, staticRenderFns } from "./HolidaysTableHeader.vue?vue&type=template&id=46980ccb&"
import script from "./HolidaysTableHeader.vue?vue&type=script&lang=js&"
export * from "./HolidaysTableHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports